// extracted by mini-css-extract-plugin
export default {"dialogHeader":"AuthenticationModal_dialogHeader__1hs3t","formRoot":"AuthenticationModal_formRoot__3d9Vi"};